import { TelemetryClient } from './client';

export const telemetry = new TelemetryClient();
export type { TelemetryEvent, TelemetryEventType, TelemetrySeverity } from './types';
